// Nummerierter Schritt-Indikator mit Verbindungslinien und Haken bei
// erledigten Schritten (12.10.2026) — Layout-Vorlage aus einem Claude-
// Artifact (Abrechnungs-Mockup), ersetzt die bisherige reine Button-Reihe in
// EventFormDialog.tsx und RefundWizardDialog.tsx. Rein präsentational: der
// aktive Index kommt vollständig von außen, der Status pro Schritt
// (completed/current/upcoming) wird nur aus `index` vs. `activeIndex`
// abgeleitet — es gibt bewusst KEINEN Sequenzzwang, jeder Schritt bleibt über
// seinen `onClick` jederzeit anklickbar, genau wie die bisherige Button-Reihe
// (freies Springen). Kein Status-Text unter dem Label (Nutzervorgabe,
// 12.10.2026) — "Erledigt"/"Aktuell"/"Offen" suggerierte fälschlich eine
// erzwungene Reihenfolge, obwohl frei zwischen den Schritten gesprungen
// werden kann.
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface StepperStep {
  label: string;
  onClick: () => void;
}

interface StepperProps {
  steps: StepperStep[];
  /** 0-basiert. */
  activeIndex: number;
}

export function Stepper({ steps, activeIndex }: StepperProps) {
  return (
    <div className="flex flex-1 items-start">
      {steps.map((step, index) => {
        const status =
          index < activeIndex ? 'completed' : index === activeIndex ? 'current' : 'upcoming';
        const isLast = index === steps.length - 1;

        return (
          <div key={index} className={cn('flex items-start', !isLast && 'flex-1')}>
            <button
              type="button"
              onClick={step.onClick}
              className="flex flex-col items-center gap-1.5 text-center"
            >
              <span
                className={cn(
                  'flex h-9 w-9 items-center justify-center rounded-full border-2 text-sm font-medium',
                  status === 'completed' && 'border-primary bg-primary text-primary-foreground',
                  status === 'current' && 'border-primary text-primary',
                  status === 'upcoming' && 'border-muted-foreground/30 text-muted-foreground'
                )}
              >
                {status === 'completed' ? <Check className="h-4 w-4" /> : index + 1}
              </span>
              <span
                className={cn(
                  'text-sm',
                  status === 'upcoming' ? 'text-muted-foreground' : 'font-medium'
                )}
              >
                {step.label}
              </span>
            </button>
            {!isLast && (
              <span
                className={cn(
                  'mt-[1.1rem] h-0.5 flex-1',
                  index < activeIndex ? 'bg-primary' : 'bg-muted-foreground/30'
                )}
                aria-hidden
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
